import type {
  FontStyle,
  BuilderFontStyle,
  FontPickerOptions,
} from '@wix/editor-platform-host-integration-apis';
import type {
  Length,
  FontExpanded,
  FontFamilyValue,
  FontStyleKeywordValue,
  FontWeightNumberValue,
} from '@wix/css-property-parser';
import { CssVariable, Font } from '@wix/css-property-parser';
import type { DocumentServices } from '../types';

export const toCssVariable = (value: string) => {
  if (value.startsWith('--')) {
    return `var(${value})`;
  }

  return value;
};

export const toColorValue = (
  documentServicesAPI: DocumentServices,
  value: string,
): string => {
  const parsedColor = CssVariable.parse(value);

  if (!parsedColor?.CSSvariable) {
    return value;
  }

  const pointer = documentServicesAPI.global.variables.getPointerByCssVarName(
    parsedColor.CSSvariable.replace('--', ''),
  );

  if (!pointer) {
    return value;
  }

  const variable = documentServicesAPI.global.variables.get(pointer);
  if (!variable) {
    return value;
  }

  return `var(--${variable.cssVarName}, ${variable.value.value as string})`;
};

export const builderFontStyleToFontStyle = (
  fontStyle: BuilderFontStyle,
): FontStyle => {
  const parsedFont = Font.parse(fontStyle.value) as FontExpanded;

  const csvFontFamilies = (
    parsedFont?.fontFamily as FontFamilyValue
  )?.families?.join(',');

  const fontSize = (parsedFont?.fontSize as Length)?.value;

  const fontWeightValue = (parsedFont?.fontWeight as FontWeightNumberValue)
    ?.value;

  const isBold = fontWeightValue >= 700;

  const isItalic =
    (parsedFont?.fontStyle as FontStyleKeywordValue)?.keyword === 'italic';

  const cssVariableName = fontStyle.cssVarName
    ? `--${fontStyle.cssVarName}`
    : undefined;

  const fontValue: FontStyle = {
    theme: fontStyle.name,
    family: csvFontFamilies,
    size: fontSize,
    bold: isBold,
    italic: isItalic,
    underline: fontStyle.textDecoration === 'underline',
    cssVariableName,
  };
  return fontValue;
};

export const mapFontPickerOptions = (
  options: FontPickerOptions,
): FontPickerOptions => {
  return {
    ...options,
    componentStyle: options.componentStyle
      ? {
          ...options.componentStyle,
          ...(options.componentStyle.style ? options.componentStyle.style : {}),
          theme:
            options.componentStyle.editorKey?.replace?.('--', '') || undefined,
        }
      : undefined,
  };
};
